/*
  Optimize Minerals — PDP tab strip.

  Plain tablist behaviour: click or arrow-key to switch, one panel visible.
  Panels are hidden with the `hidden` attribute rather than CSS alone, so the
  inactive copy is out of the accessibility tree and out of find-in-page.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.opTabsReady) return;
    root.dataset.opTabsReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.op-tabs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.op-tabs__panel'));
    if (!tabs.length) return;

    function select(i) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = (i + d + tabs.length) % tabs.length;
        select(next);
        tabs[next].focus();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-op-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
